// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
export const REQUIRED_GRANULAR_SCOPES = [
	'read:project:jira',
	'read:issue-type:jira',
	'read:user-configuration:jira',
	'read:user:jira',
	'read:issue:jira',
	'read:priority:jira',
	'read:label:jira',
	'read:license:jira',
	'read:field:jira',
	'read:field-configuration:jira',
	'write:field-configuration:jira',
	'write:field.default-value:jira',
	'write:field:jira',
] as const;

export const REQUIRED_COARSE_SCOPES = [
	'manage:jira-configuration',
	'read:jira-user',
	'read:jira-work',
	'write:jira-work',
] as const;
